<template>
	<el-dialog title="新增违章" v-model="isAdd" width="60%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<!-- <p class="platTitle">基础信息</p> -->
			<div class="info-input-container">
				<div class="flex flex-y-start flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>违章车牌</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorVehicleId" filterable placeholder="请选择" @change="vehicleHeadChange">
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehHeadNo"
									:value="item.vehicleId">
									<span style="float: left">{{ item.vehHeadNo }}</span>
									<span style="
															          float: right;
															          color: var(--el-text-color-secondary);
															          font-size: 13px;
															        ">
										{{ item.vehAffOrgName }}
									</span>
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>司机</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorVehicleId" filterable placeholder="请选择" @change="vehicleHeadChange">
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehHeadNo"
									:value="item.vehicleId">
									<span style="float: left">{{ item.vehHeadNo }}</span>
									<span style="
																				          float: right;
																				          color: var(--el-text-color-secondary);
																				          font-size: 13px;
																				        ">
										{{ item.vehAffOrgName }}
									</span>
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>违章项目</span>
						</div>
						<el-input v-model="whPhone" class="platItemRigth2" placeholder="请输入违章项目" />
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>违章地点</span>
						</div>
						<el-input v-model="whPhone" class="platItemRigth2" placeholder="请输入违章地点" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>违章日期</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="lorLoadpTime" type="datetime" :clearable="false"
								placeholder="请选择日期" @change="getlorLoadpTime">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>扣分</span>
						</div>
						<el-input v-model="whPhone" class="platItemRigth" placeholder="请输入扣分数" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>罚款金额</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入金额" />
							<div class="link-box">
								<i class="el-icon-link"></i>元
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>司机承担金额</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入金额" />
							<div class="link-box">
								<i class="el-icon-link"></i>元
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>公司承担金额</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入金额" />
							<div class="link-box">
								<i class="el-icon-link"></i>元
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>公司支付账户</span>
						</div>
						<el-input v-model="whPhone2" class="platItemRigth" placeholder="请输入支付账户" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>处理日期</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="lorLoadpTime" type="datetime" :clearable="false"
								placeholder="请选择日期" @change="getlorLoadpTime">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>处理结果</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorGoods" placeholder="请选择处理结果">
								<el-option label="未处理" :value="1" />
								<el-option label="已处理" :value="2" />
							</el-select>
						</div>
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注</span>
						</div>
						<el-input v-model="whPhone" class="platItemRigth2" placeholder="请输入备注" />
					</div>
				</div>
			</div>


			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<div class="confirm_btn" v-on:click="submit()">确定</div>
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>
			<!-- 
			<Address ref="addressRef" v-if="isAddress" @getAddressData="getAddressData" /> -->
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	// import Address from "./address";
	export default defineComponent({
		components: {
			// Address
		},
		name: "Add",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData", "getSiteAddData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			const getSiteAddData = (addtype) => {
				context.emit("getSiteAddData", addtype);
			};
			onMounted(() => {
				nextTick(() => {
					getVehicleList(); //获取车辆
					//getProvinceList(); //获取省份
					//getProviderList(); //获取客商
				});
			});
			const data = reactive({
				isAdd: false,
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				ProviderList: [], //所属客商
				vehHeadList: [],
				lorVehicleId: null, //运力车辆
				isAddress: false,
				addType: "",


				whProvider: "",
				whType: "",
				whName: "",
				whPcode: "",
				whCcode: "",
				whAcode: "",
				whAddr: "",
				whLnglat: "",
				whContact: "",
				whPhone: "",
				whContact2: "",
				whPhone2: "",
				whRemark: ""
			});
			//重置数据
			const init = (id, addType) => {
				data.isAdd = true;
				data.whProvider = "";
				data.whType = "";
				data.whName = "";
				data.whPcode = "";
				data.whCcode = "";
				data.whAcode = "";
				data.whAddr = "";
				data.whLnglat = "";
				data.whContact = "";
				data.whPhone = "";
				data.whContact2 = "";
				data.whPhone2 = "";
				data.whRemark = "";
				data.addType = "";
				data.vehHeadList = [];
				data.lorVehicleId = null; //运力车辆

				if (id !== null && id !== undefined && id !== "") {
					data.whProvider = id;
					data.whType = addType;
					data.addType = "ex";
				}
			};

			const dialogClosedHandle = () => {
				data.isAdd = false;
			};
			const closeModal = () => {
				data.isAdd = false;
			};
			const submit = async () => {
				// if (data.whName == "") {
				// 	proxy.$message.error("请填写司机名称");
				// 	return;
				// }
				// if (data.whContact == "") {
				// 	proxy.$message.error("请填写联系人");
				// 	return;
				// }
				// if (data.whPhone == "") {
				// 	proxy.$message.error("请填写联系电话");
				// 	return;
				// }
				// if (data.whType == "") {
				// 	proxy.$message.error("请选择站点类型");
				// 	return;
				// }
				// if (data.whProvider == "") {
				// 	proxy.$message.error("请选择客商类型");
				// 	return;
				// }

				// let params = {
				// 	whProvider: data.whProvider,
				// 	whType: data.whType,
				// 	whName: data.whName,
				// 	whPcode: data.whPcode,
				// 	whCcode: data.whCcode,
				// 	whAcode: data.whAcode,
				// 	whAddr: data.whAddr,
				// 	whLnglat: data.whLnglat,
				// 	whContact: data.whContact,
				// 	whPhone: data.whPhone,
				// 	whContact2: data.whContact2,
				// 	whPhone2: data.whPhone2,
				// 	whRemark: data.whRemark

				// }

				// const r = await proxy.$http.post(apiObj.siteSave, params)
				// console.log(r);
				// if (r.code === 0 || r.respCode === '0000') {
				// 	proxy.$message.success(r.msg || r.respMsg);
				// 	if (data.addType == "ex") {
				// 		getSiteAddData(data.whType);
				// 	} else {
				// 		getData();
				// 	}
				// 	data.isAdd = false;
				// } else {
				// 	proxy.$message.error(r.msg || r.respMsg);
				// }
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};

			//选择运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};

			//获取所属客商
			const getProviderList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderList = res.rows;
				}
			};

			const getProvinceList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/province/list", params);
				console.log(res);
				if (res.code == 0) {
					data.provinceList = res.rows;
				}
			};

			const getConProvince = (ev) => {
				console.log(ev);
				data.cityList = [];
				data.orgCity = "";
				data.areaList = [];
				data.orgArea = "";
				getCityList(ev);
			};

			const getCityList = async (code) => {
				let params = {
					provinceCode: code,
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/city/list", params);
				console.log(res);
				if (res.code === 0) {
					data.cityList = res.rows;
				}
			};

			const getConCity = (ev) => {
				data.areaList = [];
				data.orgArea = "";
				getAreaList(ev);
			};

			const getAreaList = async (code) => {
				let params = {
					cityCode: code,
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/area/list", params);
				console.log(res);
				if (res.code == 0) {
					data.areaList = res.rows;
				}
			};

			// 添加 根目录
			const mapAddress = () => {
				data.isAddress = true;
				nextTick(() => {
					proxy.$refs.addressRef.init(data.whAddr, data.whLnglat);
				});
			};

			//获取地址数据
			const getAddressData = (addressvaule, lng, lat) => {
				data.whAddr = addressvaule;
				data.whLnglat = lng + "," + lat;

			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				getSiteAddData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getConProvince,
				getConCity,
				mapAddress,
				getAddressData,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}



	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 10px;
	}

	.platItemLeft {
		min-width: 90px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth2 {
		width: 100%;
		padding-left: 20px;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.input_box {
		margin-left: 20px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 77%;
		height: 35px;
		padding-left: 0px;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #606266;
		cursor: pointer;
		width: 60px;
		text-align: right;
	}

	.custom-input {
		color: #606266;
		/* 输入文本颜色 */
	}

	.custom-input::placeholder {
		color: #c0c4cc;
		/* placeholder文本颜色 */
	}
</style>